import axios from 'axios';
import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { dataUser } from '../Helpers/util';
import Header from '../Layout/Header';
import './css/wallet-dashboard.css';
import wallelBalicon from './img/balance-icon-60x60.svg';
import PeopleIcon from './img/people-icon.svg';
import insufficientBalIcon from './img/insufficientBal-icon.png';
import SuccessIcon from './img/Success-Icon.png';
import ProgressIcon from './img/Progress-Icon.png';
import geographic from './img/geographic.png';
import moment from 'moment';
import { MultiSelect } from 'react-multi-select-component';
import Sidebar from "../Layout/Sidebar";
import { Layout } from "antd";
import CustomHeader from "../Layout/Header";
import axiosInstance from '../../utils/axiosInstance';
import SwInput from '../Common/FormComponent/SwInput';
import SwCheckbox from '../Common/FormComponent/SwCheckbox';
import SwMultiSelect from '../Common/SwMultiSelect/SwMultiSelect';
import SwButton from '../Common/SwButtons/SwButtons';
import AntDTable from '../Common/AntDTable/AntDTable';
import SwModal from '../Common/SwModal/SwModal';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

function PointDistribution() {

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pointDistributionUser, setPointDistributionUser] = useState([]);
  const [spinner, setSpinner] = useState(true);
  const [walletBalance, setWalletBalance] = useState('');
  const [distributionValues, setDistributionValues] = useState({});
  const [openingBalance, setOpeningBalance] = useState(0);
  const [defaultValue, setDefaultValue] = useState(''); // State to track default value
  const [distributionStatus, setDistributionStatus] = useState('');
  const [distributing, setDistributing] = useState(false); // submit in-flight
  const distributingRef = useRef(false); // guards against rapid double-clicks
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];
  const [date1, setDate1] = useState(todayStr);
  const [location, setLocation] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const toggleCollapsed = () => {
    setCollapsed((prevState) => !prevState);
  };



  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);


  const threeMonthsFromToday = new Date();
  threeMonthsFromToday.setMonth(today.getMonth() + 3);

  if (threeMonthsFromToday.getDate() !== today.getDate()) {
    threeMonthsFromToday.setDate(0);
  }

  const maxDateStr = threeMonthsFromToday.toISOString().split('T')[0];

  const handleSelectAll = useCallback(() => {
    const nextSelectAll = !selectAll;
    setSelectAll(nextSelectAll);
    if (nextSelectAll) {
      const allUserIds = pointDistributionUser.map(row => row.userId);
      setSelectedRows(allUserIds);
      if (defaultValue !== '' && parseFloat(defaultValue) >= 0) {
        const filled = {};
        pointDistributionUser.forEach(user => {
          filled[user.userId] = defaultValue;
        });
        setDistributionValues(filled);
      }
    } else {
      setSelectedRows([]);
      const cleared = {};
      pointDistributionUser.forEach(user => {
        cleared[user.userId] = '';
      });
      setDistributionValues(cleared);
    }
  }, [selectAll, pointDistributionUser, defaultValue]);

  const redirectDashboard = () => {
    window.location.href = '/wallet-dashboard';
  };
  // Function to handle selecting/deselecting individual rows
  const handleRowSelect = useCallback(userName => {
    const isCurrentlySelected = selectedRows.includes(userName);
    if (isCurrentlySelected) {
      setSelectedRows(selectedRows.filter(row => row !== userName));
      setDistributionValues(prev => ({ ...prev, [userName]: '' }));
    } else {
      setSelectedRows([...selectedRows, userName]);
      if (defaultValue !== '' && parseFloat(defaultValue) >= 0) {
        setDistributionValues(prev => ({ ...prev, [userName]: defaultValue }));
      }
    }
  }, [selectedRows, defaultValue]);

  // Function to handle point distribution change for a user
  // Function to handle point distribution change for a user
  const handlePointDistributionChange = useCallback((userName, value) => {
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue > 0) {
      setDistributionValues(prevState => ({
        ...prevState,
        [userName]: numericValue,
      }));
    } else {
      setDistributionValues(prevState => ({
        ...prevState,
        [userName]: '',
      }));
    }
  }, []);

  // Function to calculate the point provisioned value for a user
  const calculatePointProvisioned = userName => {
    return distributionValues[userName] || '';
  };

  const getPointDistributionUser = async () => {
    setSpinner(true); // Set spinner to true whenever the function is called
    try {
      let authToken = JSON.parse(localStorage.getItem('headData'));

      let config = {
        method: 'post',
        url: `${process.env.REACT_APP_API_URL}wallet/getUsersForDistribution/${UserObj ? UserObj.company_id : null
          }`,
        headers: {
          'Authorization': authToken?.spintlyToken,
          'Content-Type': 'application/json'
        },
        data: { "locationIds": selectedLocations.map(loc => loc.value) }
      };
      const res = await axios.request(config);

      if (res.data.statusValue === 200) {
        setPointDistributionUser(res.data.data);
        // Initialize distribution values for each user
        const initialDistributionValues = {};
        res.data.data.forEach(user => {
          initialDistributionValues[user.userId] = '';
        });
        setDistributionValues(initialDistributionValues);
      }
      setSpinner(false); // Set spinner to false after data is fetched
    } catch (error) {
      console.error(
        'Error occurred while fetching point distribution users:',
        error,
      );
      setSpinner(false); // Set spinner to false if there's an error
    }
  };

  const source = axios.CancelToken.source();
  const getCurrentWalletBalance = async () => {
    try {
      const authToken = localStorage.getItem("token");


      // Use await to handle the async axios request
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL}commerce/wallet/v2/company/getCompanyWalletBalance/${UserObj ? UserObj.company_id : null}`,
        {
          headers: {
            Authorization: `${authToken}`,
          },
          cancelToken: source.token, // Ensure that cancel token is set
        }
      );

      if (res.data.statusValue === 200) {
        setOpeningBalance(res.data.balance);
        setWalletBalance(res.data.balance);
      }

    } catch (error) {
      console.error('Error occurred while fetching wallet balance:', error);
    }
  };

  const handleSearchChange = e => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const filteredUsers = pointDistributionUser.filter(user =>
    user.user_name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const fetchLocations = async () => {
    try {
      const authToken = JSON.parse(localStorage.getItem('headData'))
        ?.spintlyToken;
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
        {
          params: { spoc: UserObj.rec_id, client: UserObj.company_id },
          headers: {
            Authorization: authToken,
          },
        },
      );
      if (res.data.status === 'success') {
        setLocation(res.data.data);
        setSelectedLocations(
          res.data.data.map(loc => ({
            label: loc.location_name,
            value: loc.rec_id,
          })),
        );
      }
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  useEffect(() => {
    getCurrentWalletBalance();
    fetchLocations();
  }, []);

  const handleLocationChange = selected => {
    setSelectedLocations(selected);
  };

  useEffect(() => {
    getPointDistributionUser();
  }, [selectedLocations])

  // Function to calculate the count of selected checkboxes
  const calculateSelectedCount = () => {
    return selectedRows.length;
  };

  // Sum only the distribution values of selected rows — this matches what
  // handleContinueDistribution sends to the API.
  const calculateTotalPoints = () => {
    let totalPoints = 0;
    selectedRows.forEach(userName => {
      totalPoints += parseFloat(distributionValues[userName]) || 0;
    });
    return totalPoints;
  };

  const remainingBalance = openingBalance - calculateTotalPoints();

  // Function to determine if the input should be enabled for a specific row
  // Function to determine if the input should be enabled for a specific row
  const isInputEnabled = useCallback(userName => {
    // Check if the userName exists in the selectedRows array
    return selectedRows.includes(userName);
  }, [selectedRows]);

  // Function to handle default value change
  const handleDefaultValueChange = e => {
    const value = e.target.value;
    if (value === '' || value >= 0) {
      setDefaultValue(value);
    }
  };

  // Function to handle Continue Distribution button click
  const handleContinueDistribution = async () => {
    try {
      // Prepare data in the required format
      const distributionData = pointDistributionUser
        .filter(user => selectedRows.includes(user.userId))
        .map(user => {
          const userObj = {
            userId: String(user.userId),
            points: parseFloat(distributionValues[user.userId]),
          };

          if ([2457, 2552, 55, 3194, 2866].includes(UserObj?.company_id)) {
            userObj.applicableTill = moment(date1)
              .endOf('day')
              .unix();
          }

          return userObj;
        });

      // Get authentication token from localStorage
      const authToken = JSON.parse(localStorage.getItem('headData'))
        ?.spintlyToken;

      if (!authToken) {
        throw new Error('Authentication token not found');
      }

      // Call the API with the distribution data
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}commerce/wallet/v2/company/distributePoints/${UserObj?.company_id
        }`,
        distributionData,
        {
          headers: {
            Authorization: authToken,
          },
        },
      );

      // Handle successful response
      setDistributionStatus(response.data.statusValue);
    } catch (error) {
      // Handle errors
      console.error('Error sending distribution data:', error);
    }
  };

  const hasEmptyDistribution = selectedRows.some(
    userName => !distributionValues[userName],
  );

  const locationOptions = location.map(loc => ({
    label: loc.location_name,
    value: loc.rec_id,
  }));

  const columns = useMemo(() => [
    {
      title: (
        <SwCheckbox
          label={''}
          checked={selectAll}
          onChange={handleSelectAll}
        />
      ),
      key: 'checkbox',
      width: '50px',
      render: (text, record) => (
        <SwCheckbox
          checked={selectedRows.includes(record.userId)}
          onChange={() => handleRowSelect(record.userId)}
          label={''}
        />
      ),
    },
    {
      title: 'USER NAME',
      dataIndex: 'user_name',
      key: 'user_name',
    },
    {
      title: 'EMAIL',
      dataIndex: 'user_email',
      key: 'user_email',
    },
    {
      title: 'PHONE',
      dataIndex: 'user_phone',
      key: 'user_phone',
    },
    {
      title: 'LOCATION',
      dataIndex: 'location_name',
      key: 'location_name',
    },
    {
      title: 'POINT DISTRIBUTION',
      key: 'point_distribution',
      render: (text, record) => (
        <SwInput
          value={distributionValues[record.userId]}
          onChange={e =>
            handlePointDistributionChange(
              record.userId,
              e.target.value,
            )
          }
          disabled={!isInputEnabled(record.userId)}
        />
      ),
    },
    {
      title: 'POINT PROVISIONED',
      key: 'point_provisioned',
      render: (text, record) => (
        distributionValues[record.userId] != 0 ? (
          <div className="d-flex align-items-center">
            <img
              src={wallelBalicon}
              width={'12px'}
              className="mr-1"
            />
            <span>
              {calculatePointProvisioned(
                record.userId,
              )}
            </span>
          </div>
        ) : (
          ''
        )
      ),
    },
  ], [selectAll, selectedRows, distributionValues, handleSelectAll, handleRowSelect, handlePointDistributionChange, isInputEnabled]);

  return (
    <>
      <Layout>

        <Sidebar collapsed={collapsed} />

        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />


        <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>

          <div className="PageContent PointDistributionPage-none">
            <div className="">
              <div className="row align-items-center justify-content-between">
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-12">
                      <div className='SwHeading'>
                        <h2>Point Distribution</h2>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">
                          Default Value (optional)
                        </label>
                        <SwInput
                          value={defaultValue}
                          onChange={handleDefaultValueChange}
                          placeholder="Enter the amount"
                        />
                      </div>

                    </div>
                    <div className="col-md-4">
                      <div className="SwFormGroup">
                        <label className="SwFormLabel invisible">No Label</label>
                        <SwInput
                          placeholder="Search By User Name"
                          value={searchTerm}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="SwFormGroup">
                        <label className='SwFormLabel invisible'>No Label</label>
                        <SwMultiSelect
                          options={locationOptions}
                          value={selectedLocations}
                          onChange={handleLocationChange}
                          labelledBy="Select Locations"
                          placeholder="Select Locations"
                          overrideStrings={{
                            allItemsAreSelected: "All locations are selected",
                          }}
                        />

                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <img src={geographic} className="img-fluid" />
                </div>
              </div>
              {/* Point Distribution Table */}
              <div className="row">
                <div className="col-12">
                  <div className="PoinDistributionTable">
                    <div className="mt-2">
                      <AntDTable
                        columns={columns}
                        size="small"
                        dataSource={filteredUsers}
                        loading={spinner}
                        pagination={true}
                        rowKey="userId"
                        currentPage={currentPage}
                        onPageChange={(page) => setCurrentPage(page)}
                        key={searchTerm}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Point Distribution Cart */}
            <div className="PointCartContainer">
              <div className="OpenningRemainBal_Box">
                <div className="OpenningRemainBal">
                  <label>Opening Balance:</label>
                  <div className="OpenningRemainValue">
                    <img src={wallelBalicon} className="ValcoinIcon" />
                    <span>{walletBalance} </span>
                  </div>
                </div>
                <div className="OpenningRemainBal">
                  <label>Remaining Balance:</label>
                  <div className="OpenningRemainValue">
                    <img src={wallelBalicon} className="ValcoinIcon" />
                    <span>{remainingBalance}</span>
                  </div>
                </div>
              </div>
              <div className="CartTotalPointsBox">
                <div className="CartTotalPoints">
                  <label>People Selected: </label>
                  <div className="CartTotalPoints_Value">
                    <img src={PeopleIcon} />
                    <span>{calculateSelectedCount()}</span>
                  </div>
                </div>
                <div className="CartTotalPoints">
                  <label>Total Points: </label>
                  <div className="CartTotalPoints_Value">
                    <img src={wallelBalicon} />
                    <span>{calculateTotalPoints()}</span>
                  </div>
                </div>

                <SwButton
                  disabled={!selectedRows.length || hasEmptyDistribution}
                  icon={<i className="bi bi-arrow-right-circle"></i>}
                  iconPosition="end"
                  onClick={() => {
                    if (remainingBalance < 0) {
                      setShowAlertModal(true);
                    } else {
                      setShowReviewModal(true);
                    }
                  }}
                >
                  Proceed to review
                </SwButton>

              </div>
            </div>

            {/* Point DIstribution Alert modal Insufficient */}
            <SwModal
              show={showAlertModal}
              onClose={() => setShowAlertModal(false)}
              className="sw-small-modal"
              footer={
                <div className="d-flex justify-content-center">
                  <SwButton
                    variant="dark-outline"
                    size="sm"
                    onClick={() => setShowAlertModal(false)}
                  >
                    Close
                  </SwButton>
                </div>
              }
            >
              <div className="text-center">
                <img src={insufficientBalIcon} className="mb-3" width={100} />
                
                <div className='SwSubHeading Hv2'>
                  <h3 className='mb-2'>Insufficient Balance</h3>
                </div>
                <p>Please topup your wallet</p>
              </div>
            </SwModal>


            {/* Point DIstribution Alert modal Success */}
            <SwModal
              show={showSuccessModal}
              onClose={() => setShowSuccessModal(false)}
              className="sw-small-modal"
              footer={
                <div className="d-flex justify-content-center">
                  <SwButton
                    variant="dark-outline"
                    size="sm"
                    onClick={() => setShowSuccessModal(false)}
                  >
                    Close
                  </SwButton>
                </div>
              }
            >
              <div className="text-center">

                {distributionStatus === 200 && (
                  <>
                    <img src={SuccessIcon} className="mb-3" width={100} />
                    <div className='SwSubHeading Hv2'>
                      <h3 className='mb-2'>Point distribution successful</h3>
                    </div>
                    <p>Your employees balance will be updated shortly</p>
                  </>
                )}

                {distributionStatus === 400 && (
                  <>
                    <img src={insufficientBalIcon} className="mb-3" />
                    <h3 className="SwModalSubHeading">Point distribution failed</h3>
                    <p>Please contact help support</p>
                  </>
                )}

                {!distributionStatus && (
                  <>
                    <img src={ProgressIcon} className="mb-3" />
                    <h3 className="SwModalSubHeading">Distribution in progress...</h3>
                    <p>Please wait until your previous request is processed</p>
                  </>
                )}

              </div>
            </SwModal>


            {/* PointReviewPopup Modal */}
            <SwModal
            show={showReviewModal}
            onClose={() => setShowReviewModal(false)}
            title="Points Distribution"
            className="sw-default-modal"
            footer={
              <div className="d-flex justify-content-end gap-3">
                <SwButton
                  variant="dark-outline"
                  size="sm"
                  onClick={() => setShowReviewModal(false)}
                >
                  Cancel
                </SwButton>

                <SwButton
                  variant="primary"
                  size="sm"
                  loading={distributing}
                  disabled={distributing}
                  onClick={async () => {
                    // Guard with a ref so a rapid double-click can't fire twice
                    // before the `distributing` state re-renders the button.
                    if (distributingRef.current) return;
                    distributingRef.current = true;
                    setDistributing(true);
                    try {
                      await handleContinueDistribution();
                      setShowReviewModal(false);
                      setShowSuccessModal(true);
                    } finally {
                      distributingRef.current = false;
                      setDistributing(false);
                    }
                  }}
                >
                  Distribute
                </SwButton>
              </div>
            }
          >
            <p className="SwModalSubHeading">
              Here is your overall summary for the distribution
            </p>

            <div className="PointReviewPopup_Cntent">

              <div className="TotalPointsBox">
                <img src={wallelBalicon} />
                <h4>{calculateTotalPoints()}</h4>
                <h5>Total Points</h5>
              </div>

              <div className="TotalPointsBox">
                <img src={PeopleIcon} />
                <h4>{calculateSelectedCount()}</h4>
                <h5>People Selected</h5>
              </div>

              <div className="TotalPointsBox OpeningBalanceBox">
                <label>Opening Balance:</label>
                <div className="BalanceValue">
                  <img src={wallelBalicon} />
                  <span>{walletBalance}</span>
                </div>

                <label className="pt-3">Remaining Balance:</label>
                <div className="BalanceValue">
                  <img src={wallelBalicon} />
                  <span>{remainingBalance}</span>
                </div>
              </div>

            </div>

            {[2457, 2552, 55, 3194, 2866].includes(UserObj?.company_id) && (
              <div className="ExpiryOfPoint mt-3">
                <label>Enter expiry date of Points</label>

                <input
                  type="date"
                  min={todayStr}
                  max={maxDateStr}
                  className="form-control"
                  onChange={e => setDate1(e.target.value)}
                  value={date1}
                />

                <p className="small">
                  Points will expire at the end of the selected day
                </p>
              </div>
            )}

          </SwModal>

          </div>
        </Layout>

      </Layout>
    </>
  );
}

export default PointDistribution;
